import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { CheckListItem } from '../types';
import { apiFetch } from '@/core';
import env from '@/env';

export const updateAuditorVisitById = async ({
  visitId,
  data,
}: {
  visitId: string;
  data: { datStart: string; datEnd: string };
}): Promise<CheckListItem> => {
  console.log(data);
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/update/${visitId}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as CheckListItem;
  return response;
};
